/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';
import {
  AgentAssignment,
  DataLeadCard,
  DisabledType,
  DisabledTypes,
  ExecutiveList,
  LeadId,
} from '@interfaces';
import { LeadService, OrderService } from '@services';
import { getChannelLabel } from '@utils';

@Component({
  selector: 'unicon-topbar-field',
  templateUrl: './topbar-field.component.html',
})
export class TopbarFieldComponent {
  @Input() lastSessionTime!: string;
  @Input() leadId?: string;
  @Input() isBotMuted?: boolean;
  @Input() dataLead?: DataLeadCard;
  @Input() isActivated!: boolean;
  @Input() leadCardList?: DataLeadCard[];
  @Input() orderId!: string;
  @Output() nextOrder = new EventEmitter<DataLeadCard>();
  @Output() result: EventEmitter<string> = new EventEmitter<string>();
  protected isLoading: boolean = false;
  protected isLoadingArchive: boolean = false;
  protected showMenu: boolean = false;
  protected showMenuAgents: boolean = false;
  protected showSubmenu: boolean = false;
  protected isLoadingAgents?: boolean;
  protected agentsList?: ExecutiveList[] = [];
  protected isLoadingAssignment: boolean = false;
  protected selectedOptionAgent!: ExecutiveList;
  protected visibleOptions: boolean = false;

  protected disabledTypes: DisabledTypes[] = [];
  protected selectedOption!: any;
  protected currentTime: string = '';
  protected elapsedTime: string = '';
  private intervalId: any;
  @ViewChild('menuContainer') menuContainer!: ElementRef;
  @ViewChild('menuAgentsRef') menuAgentsRef!: ElementRef;
  @ViewChild('submenuRef') submenuRef!: ElementRef;

  constructor(
    private leadService: LeadService,
    private orderService: OrderService,
  ) {}

  ngOnInit(): void {
    this.leadArchivingTypes();
    this.calculateElapsedTime();

    this.intervalId = setInterval(() => {
      this.calculateElapsedTime();
    }, 1000);
  }

  protected getChannelNameLabel(): string {
    return getChannelLabel(this.dataLead?.channelName);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInsideMenu = this.menuContainer?.nativeElement.contains(
      event.target,
    );
    const clickedMenuAgents = this.menuAgentsRef?.nativeElement.contains(
      event.target,
    );
    const clickedSubmenu = this.submenuRef?.nativeElement.contains(
      event.target,
    );

    if (!clickedInsideMenu && this.showMenu) {
      this.showMenu = false;
    }

    if (!clickedMenuAgents && !clickedSubmenu) {
      this.showMenuAgents = false;
      this.showSubmenu = false;
    }
  }

  protected onBotMute(): void {
    this.isLoading = true;
    const request: LeadId = {
      chatId: this.leadId || '',
    };
    this.leadService.chatBotMute(request).subscribe({
      next: () => {
        this.isLoading = false;
        this.isBotMuted = !this.isBotMuted;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  protected leadArchivingTypes() {
    this.orderService.getDisabledTypes().subscribe({
      next: (disabledtypes: DisabledTypes[]) => {
        this.disabledTypes = disabledtypes;
      },
    });
  }

  protected onShowDisabledTypes() {
    this.showMenu = !this.showMenu;
    if (!this.showMenu) {
      this.selectedOption = null;
    }
  }

  protected onLeadArchive() {
    this.showMenu = false;
    this.isLoadingArchive = true;
    const request: DisabledType = {
      orderId: this.orderId,
      orderDisabledTypeId: this.selectedOption.id,
    };
    if (this.selectedOption.id) {
      this.orderService.disabledOrderId(this.orderId, request).subscribe({
        next: () => {
          this.isLoadingArchive = false;
          this.onNextLead();
        },
        error: () => {
          this.isLoadingArchive = false;
        },
      });
    }
  }

  protected onNextLead() {
    this.showMenu = !this.showMenu;
    const orderIndex: number = this.leadCardList
      ? this.leadCardList?.findIndex(obj => obj['orderId'] === this.orderId)
      : 0;
    this.leadCardList!.splice(orderIndex, 1);
    const nextIndex = orderIndex >= this.leadCardList!.length ? 0 : orderIndex;
    const isEmpty = this.leadCardList!.length === 0;
    const nextOrder = !isEmpty ? this.leadCardList![nextIndex] : undefined;

    this.nextOrder.emit(nextOrder);
    if (isEmpty) {
      this.result.emit('close');
    }

    this.selectedOption = null;
  }

  protected formatDateWithIntl(date: string): string {
    const newDate = new Date(date);
    return new Intl.DateTimeFormat('es-ES', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
    }).format(newDate);
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private calculateElapsedTime() {
    const lastMessageDate = new Date(this.lastSessionTime);
    const now = new Date();
    const diffInMs = now.getTime() - lastMessageDate.getTime();

    const hours = Math.floor(diffInMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffInMs % (1000 * 60)) / 1000);

    this.elapsedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  protected assignAnotherExecutive(event: Event) {
    event.stopPropagation();
    this.isLoadingAgents = true;
    this.showSubmenu = !this.showSubmenu;
    this.visibleOptions = true;
    if (this.leadId) {
      this.leadService.getAllAgents(this.leadId).subscribe({
        next: (agents: ExecutiveList[]) => {
          this.isLoadingAgents = false;
          this.agentsList = agents;
          this.visibleOptions = false;
        },
        error: () => {
          this.isLoadingAgents = false;
          this.visibleOptions = false;
        },
      });
    }
  }

  protected toggleMenuLead() {
    this.showMenuAgents = !this.showMenuAgents;
    if (this.showSubmenu) {
      this.showSubmenu = !this.showSubmenu;
    }
  }

  protected onAssignAnotherAgent() {
    this.isLoadingAssignment = true;
    const request: AgentAssignment = {
      agentIdToReassign: this.selectedOptionAgent.id,
    };
    if (this.leadId) {
      this.leadService.updateAgentAssignment(this.leadId, request).subscribe({
        next: () => {
          this.isLoadingAssignment = false;
          this.showMenuAgents = false;
          this.showSubmenu = false;
          //this.result.emit();
        },
        error: () => {
          this.isLoadingAssignment = false;
        },
      });
    }
  }
}
